/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Email_Alerts_DescInputs */

const en_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get notified about new orders and messages`)
};

const es_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe notificaciones sobre nuevos pedidos y mensajes`)
};

const fr_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez averti des nouvelles commandes et messages`)
};

const de_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werde über neue Bestellungen und Nachrichten informiert`)
};

const ja_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新規注文やメッセージの通知を受け取る`)
};

const zh_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取新订单和消息的通知`)
};

const ar_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تلقَ إشعارات حول الطلبات والرسائل الجديدة`)
};

const id_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapatkan notifikasi tentang pesanan dan pesan baru`)
};

const it_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi notifiche su nuovi ordini e messaggi`)
};

const ru_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получать уведомления о новых заказах и сообщениях`)
};

const pt_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja notificado sobre novos pedidos e mensagens`)
};

const ko_settings_email_alerts_desc = /** @type {(inputs: Settings_Email_Alerts_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새로운 주문 및 메시지에 대한 알림 받기`)
};

/**
* | output |
* | --- |
* | "Get notified about new orders and messages" |
*
* @param {Settings_Email_Alerts_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_email_alerts_desc = /** @type {((inputs?: Settings_Email_Alerts_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Email_Alerts_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_email_alerts_desc(inputs)
	if (locale === "es") return es_settings_email_alerts_desc(inputs)
	if (locale === "fr") return fr_settings_email_alerts_desc(inputs)
	if (locale === "de") return de_settings_email_alerts_desc(inputs)
	if (locale === "ja") return ja_settings_email_alerts_desc(inputs)
	if (locale === "zh") return zh_settings_email_alerts_desc(inputs)
	if (locale === "ar") return ar_settings_email_alerts_desc(inputs)
	if (locale === "id") return id_settings_email_alerts_desc(inputs)
	if (locale === "it") return it_settings_email_alerts_desc(inputs)
	if (locale === "ru") return ru_settings_email_alerts_desc(inputs)
	if (locale === "pt") return pt_settings_email_alerts_desc(inputs)
	return ko_settings_email_alerts_desc(inputs)
});